import React from 'react';
import { PieceResponse } from '@/api/bol';
import { DeleteConfirmDialog } from '@/components/common/DeleteConfirmDialog';

export interface PieceDeleteDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  piece: PieceResponse | null;
}

export const PieceDeleteDialog: React.FC<PieceDeleteDialogProps> = ({
  open,
  onClose,
  onConfirm,
  piece,
}) => {
  return (
    <DeleteConfirmDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      itemType="piece"
      itemId={piece?.id || ''}
    />
  );
};
